'use strict'

/**
 * Данные сессии
 */
import * as types from '@/store/types'

const state = {
  init: false
}

const mutations = {
  [types.SESSION.set]: (state) => {
    state.init = true
  },
  [types.SESSION.reset]: (state) => {
    state.init = false
  }
}

const actions = {
  [types.SESSION.set] (context) {
    context.commit(types.SESSION.set)
  },
  [types.SESSION.reset] (context) {
    context.commit(types.SESSION.reset)
  }
}

export default {
  state,
  mutations,
  actions
}
